import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { useStaticQuery, graphql } from "gatsby"
import useTranslations from "hooks/useTranslations"
import NumberedListAnimated from "components/organisms/common/NumberedListAnimated"
import Handshake from "images/schools/handshake.svg"

const StepsSchoolsImage = ({ className }) => {
  const images = useStaticQuery(graphql`
    {
      conversationImage: file(
        relativePath: { eq: "schools/AdobeStock_340231009.jpeg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 1200)
        }
      }
    }
  `)

  return (
    <GatsbyImage
      image={getImage(images.conversationImage)}
      imgStyle={{
        objectFit: "cover",
        objectPosition: "right center",
      }}
      className={className}
    />
  )
}

export default function HowDoWeHelpSchoolsOnboarding(props) {
  const {
    schoolOnboardingHowDoWeHelpTitle,
    schoolOnboardingHelpListItem1,
    schoolOnboardingHelpListItem2,
    schoolOnboardingHelpListItem3,
    schoolOnboardingHelpListItem4,
    schoolOnboardingHelpListItem5,
    schoolOnboardingHelpListItem6,
  } = useTranslations()

  const items = [
    {
      number: <Handshake className="w-10" />,
      title: schoolOnboardingHelpListItem1,
      numberColor: "text-kkm-green",
    },
    {
      number: <Handshake className="w-10" />,
      title: schoolOnboardingHelpListItem2,
      numberColor: "text-kkm-yellow",
    },
    {
      number: <Handshake className="w-10" />,
      title: schoolOnboardingHelpListItem3,
      numberColor: "text-zinc-300",
    },
    {
      number: <Handshake className="w-10" />,
      title: schoolOnboardingHelpListItem4,
      numberColor: "text-kkm-green",
    },
    {
      number: <Handshake className="w-10" />,
      title: schoolOnboardingHelpListItem5,
      numberColor: "text-kkm-yellow",
    },
    {
      number: <Handshake className="w-10" />,
      title: schoolOnboardingHelpListItem6,
      numberColor: "text-zinc-300",
    },
  ]

  return (
    <NumberedListAnimated
      title={schoolOnboardingHowDoWeHelpTitle}
      items={items}
      Image={StepsSchoolsImage}
      theme="dark"
      {...props}
    />
  )
}
